document.addEventListener('DOMContentLoaded', function () {
   initializeScrollButtons();
});

function initializeScrollButtons() {
   const leftButton = document.querySelector('.scroll-button.left');
   const rightButton = document.querySelector('.scroll-button.right');
   const productList = document.querySelector('.variations');

   if (productList && leftButton && rightButton) {
      // Remove any existing event listeners by cloning the buttons
      leftButton.replaceWith(leftButton.cloneNode(true));
      rightButton.replaceWith(rightButton.cloneNode(true));

      // Re-select the buttons after cloning
      const newLeftButton = document.querySelector('.scroll-button.left');
      const newRightButton = document.querySelector('.scroll-button.right');

      // Helper function to update button states
      const updateButtonStates = () => {
         const scrollLeft = productList.scrollLeft;
         const maxScrollLeft = productList.scrollWidth - productList.clientWidth;

         // Disable left button if at the start
         if (scrollLeft <= 0) {
            newLeftButton.setAttribute('disabled', 'true');
         } else {
            newLeftButton.removeAttribute('disabled');
         }

         // Disable right button if at the end
         if (scrollLeft >= maxScrollLeft) {
            newRightButton.setAttribute('disabled', 'true');
         } else {
            newRightButton.removeAttribute('disabled');
         }
      };

      // Attach new click event listeners
      newLeftButton.addEventListener('click', () => {
         productList.scrollBy({ left: -100, behavior: 'smooth' });
      });

      newRightButton.addEventListener('click', () => {
         productList.scrollBy({ left: 100, behavior: 'smooth' });
      });

      // Update button states on scroll
      productList.addEventListener('scroll', updateButtonStates);

      // Initial state update
      updateButtonStates();
   } else {
      console.error('Scroll buttons or product list not found');
   }
}
